



















































































































































































































































































































































































































































/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
import { Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

/**
 * Internal dependencies.
 */
import { lazyInject } from '../../container'
import { TYPES } from '@/types'
import { SET_USER_DATA } from '@/store/authentication/constants'
import { namespace as authenticationModule } from '@/store/authentication'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import UploadPhotoInput from '@/features/account/components/forms/UploadPhotoInput.vue'
import Input from '@/components/account/form-elements/Input.vue'
import { asyncTimer } from '@/utils/helpers'

@Component({
  components: {
    Input,
    UploadPhotoInput,
    LoadingSpinner,
    VueGoogleAutocomplete
  }
})

export default class ProfileSettings extends Vue {
  @Ref('formValidator') formValidator!: { setErrors: (data: any) => void }

  @Prop({ type: Boolean, default: false }) showEdit: boolean
  @Prop({ type: Boolean, default: false }) isProfileCompleted: boolean

  @lazyInject(TYPES.AuthService)
  AuthService: any

  @lazyInject(TYPES.UserService)
  UserService: any

  selectedCommunities: Array<any> = []
  options: Array<any> = []
  user: any = null
  form: any = null
  loading: boolean = true
  element: any = null
  otherCommunity: any = null
  dontHaveABusiness: boolean = false
  dontHaveABusinessLogo: boolean = false
  userProfileImageSrc: string | null = null
  userBusinessImageSrc: string | null = null
  userProfileImageFile: File | null = null
  userBusinessImageFile: File | null = null
  isEditing: boolean = false
  updatingData: boolean = false
  serverErrors: { [key: string]: string[] } = {}
  hasAvatar: boolean = false
  hasClearedErrors: boolean = false
  locationError: boolean = false

  $refs!: {
    profileImage: Element | any,
    companyImage: Element | any,
    locationInput: Element | any
  }

  OTHER_COMMUNITY_ID!: number

  @Watch('showEdit', { immediate: true })
  onShowEdit (value: boolean) {
    this.isEditing = value
  }

  @Watch('dontHaveABusinessLogo')
  async onDontHaveABusinessLogoChange (value: boolean) {
    if (!value && !this.form.business_logo && !this.userBusinessImageFile) {
      // wait 10 ms
      // so value is updated in components
      // and then we are going to set the error
      await asyncTimer(10)

      this.formValidator.setErrors({
        business_logo: ['Please add your business logo!']
      })
    }
  }

  created () {
    if (!this.isProfileCompleted) {
      void this.promptNewUser()
    }
    this.OTHER_COMMUNITY_ID = 1
  }

  mounted () {
    this.user = this.AuthService.getAuthUser()

    this.UserService.getCommunities()
      .then((response: any) => {
        this.options = response.data.map((option: any) => {
          return {
            ...option,
            id: Number(option.id)
          }
        })

        this.form = { ...this.user }

        // use profile_image for avatar --this is only a check for validation
        this.hasAvatar = this.user.avatar ? true : false

        if (this.isProfileCompleted) {
          if (!this.form.business_name) {
            this.dontHaveABusiness = true
          }

          if (!this.form.business_logo) {
            this.dontHaveABusinessLogo = true
          }

          // if (!this.form.location) {
          //   this.locationError = true
          // }
        }

        // user `profile_image` attribute (appended) otherwise avatar field
        // wont show up if user dont have avatar set. Might as well update nav bar.
        this.userProfileImageSrc = this.user.profile_image
        this.userBusinessImageSrc = this.user.business_logo
        delete this.form.avatar
        delete this.form.business_logo

        this.user.communities.forEach((element: any, index: any) => {
          const parsedId = Number(element.id)
          this.selectedCommunities.push(parsedId)

          if (parsedId === this.OTHER_COMMUNITY_ID) {
            this.otherCommunity = element.pivot.other_community
          }
        })

        this.setDefaultErrorsIfRequired()

        this.loading = false
      })
  }

  @authenticationModule.Action(SET_USER_DATA) setUserData: (data: any) => void

  setDefaultErrorsIfRequired () {
    if (this.isProfileCompleted) {
      return
    }

    // wait for two next Ticks
    // first is to render the validation observer component
    // second is to initialize it's context
    // and then we set the errors
    this.$nextTick(async () => {
      await this.$nextTick()

      this.formValidator.setErrors({
        business_name: ['Please enter your business name!'],
        business_logo: ['Please add your business logo!'],
        avatar: ['Please add your profile image!'],
        bio: ['Please enter more about yourself!']
      })

      // check existing user data
      if (this.form.business_name) {
        this.clearError('business_name')
      }
      if (this.hasAvatar) {
        this.clearError('avatar')
      }
      if (this.form.business_logo || this.userBusinessImageSrc) {
        this.clearError('business_logo')
      }
      if (this.form.bio) {
        this.clearError('bio')
      }
    })
  }

  setProfileImageData () {
    let file = this.$refs.profileImage.files[0]

    this.userProfileImageSrc = window.URL.createObjectURL(file)
    this.userProfileImageFile = file

    this.clearError('avatar')
  }

  setBusinessImageData () {
    let file = this.$refs.companyImage.files[0]

    this.userBusinessImageSrc = window.URL.createObjectURL(file)
    this.userBusinessImageFile = file

    this.clearError('business_logo')
  }

  isLocationSet () {
    const { city, state, country } = this.form

    if (!city || city === '' || !state || state === '' || !country || country === '') {
      return false
    }

    return true
  }

  onBlurLocation () {
    // Actual dom element for the autocomplete input
    // https://github.com/olefirenko/vue-google-autocomplete/blob/master/src/VueGoogleAutocomplete.vue#L3

    let location = this.$refs.locationInput.$refs.autocomplete.value

    if (location.trim() === '') {
      this.locationError = true
      this.form.city = null
      this.form.state = null
      this.form.country = null
      this.form.location = null
    }

    if (!this.isLocationSet()) {
      this.locationError = true
    }
  }

  getLocationData (addressData: object, placeResultData: object, id: string) {
    /**
     * When the location found (vue-google-autocomplete)
     * @param {Object} addressData Data of the found location
     */
    const location: object | any = addressData

    this.form.city = location.locality
    this.form.state = location.administrative_area_level_1
    this.form.country = location.country

    if (!this.isLocationSet()) {
      this.locationError = true
    } else {
      this.locationError = false
      this.form.location = `${this.form.city}, ${this.form.state}, ${this.form.country}`
    }
  }

  toggleEdit () {
    if (this.isEditing) {
      this.updateData()
    } else {
      this.isEditing = true
      this.setDefaultErrorsIfRequired()
    }
  }

  updateData () {
    if (this.updatingData) {
      return
    }

    this.updatingData = true

    const formData = new FormData()
    this.form.communities = this.selectedCommunities

    if (this.selectedCommunities.includes(this.OTHER_COMMUNITY_ID) && this.otherCommunity) {
      this.form.other_community = this.otherCommunity
    } else if (this.otherCommunity) {
      delete this.form.other_community
    }

    if (this.userProfileImageFile) {
      formData.append('avatar', this.userProfileImageFile)
      formData.append('profile_image', this.userProfileImageFile)
    }

    if (this.userBusinessImageFile) {
      formData.append('business_logo', this.userBusinessImageFile)
    }

    if (this.dontHaveABusiness) {
      formData.set('dont_have_a_business', '1')
    }

    if (this.dontHaveABusinessLogo) {
      formData.set('dont_have_a_business_logo', '1')
    }

    // Filter out null values
    Object.keys(this.form).forEach((key: any, index: any) => {
      if (key !== 'location' && this.form[key] != null) {
        formData.append(key, this.form[key])
      }
    })

    // append existing location into form
    formData.append('location', JSON.stringify({
      city: this.form.city,
      state: this.form.state,
      country: this.form.country
    }))

    formData.append('_method', 'put')

    this.UserService.updateUser(this.user.id, formData).then((response: any) => {
      this.setUserData(response.data)

      this.updatingData = false
      this.isEditing = false
    }).catch((error: any) => {
      this.formValidator.setErrors(error.errors)

      this.updatingData = false
    })
  }

  clearError (inputName?: string) {
    this.hasClearedErrors = true

    if (!inputName) {
      return
    }

    this.formValidator.setErrors({
      [inputName]: []
    })
  }

  getError (inputName: string): string | null {
    if (inputName in this.serverErrors) {
      return this.serverErrors[inputName][0]
    }

    return null
  }

  async promptNewUser () {
    await this.$swal({
      title: 'Awesome, you made it!',
      text: 'We just need you to complete your profile to get started.',
      confirmButtonText: 'Let’s Do This'
    })
  }

  async requestDeleteAccount () {
    let result = await this.$swal({
      title: 'Delete User Account',
      text: 'You will receive a confirmation link in your email. Upon deletion, we will remove all records and files associated with this account. ',
      confirmButtonText: 'Delete!',
      confirmButtonColor: '#dc3545',
      showCancelButton: true,
      cancelButtonColor: 'lightgray',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return this.UserService.requestAccountDelete(this.user.id)
          .then((response: any) => {
            return response
          })
          .catch(async (error: any) => {
            await this.$swal({
              title: 'Oops!',
              text: error.errors
                ? typeof error.errors === 'string' ? error.errors : JSON.stringify(error.errors)
                : 'Something went wrong.',
              confirmButtonText: 'Ok'
            })
          })
      },
      allowOutsideClick: () => false
    })

    if (result.dismiss) {
      return
    }

    if (!result.value) {
      await this.$swal({
        title: 'Oops!',
        text: 'Something went wrong.',
        confirmButtonText: 'Ok'
      })

      return
    }

    await this.$swal({
      title: 'Delete Account Requested',
      text: 'We have sent a confirmation link to your email. The link expires in 30 minutes.',
      confirmButtonText: 'Ok'
    })
  }
}
